/* @ngInject */
function SharedPacksController ($scope, $translate, RepositoryService) {
  let search

  const api = {
    _resetTabObject,
    _setHeader,
    _getTabsCounts,
    _getShowMore,
    _getActive,
    _getExpired,
    _getSearch
  }

  $scope.selectedTab = 'active'

  $scope.flags = {
    loadingTabCounts: true,
    isSearching: false
  }

  this.getApi = () => api

  function activate () {
    api._resetTabObject('active', true)
    api._setHeader()
    api._getTabsCounts()
  }

  activate()

  /**
   * @param {"active" | "expired" | "search"} scopeObjectKey
   * @param {boolean} loading
   */
  function _resetTabObject (scopeObjectKey, loading = false) {
    $scope[scopeObjectKey] = {
      loading: loading,
      loadingMore: false,
      items: [],
      count: null,
      $top: 20,
      $skip: 0,
      getItems: () => {
        if (scopeObjectKey === 'active') {
          return api._getActive()
        } else if (scopeObjectKey === 'expired') {
          return api._getExpired()
        }

        return api._getSearch()
      }
    }
  }

  function _setHeader () {
    const headerInfo = RepositoryService.getHeader(
      !!$scope.searching,
      $translate.instant('repository.sidebarSections.shared'),
      {
        hasAdvancedSearch: false,
        hasFilters: false,
        advancedFilters: null,
        searchAssets: (searchTerm) => {
          if (searchTerm) {
            search = searchTerm
            $scope.flags.isSearching = true
            api._resetTabObject('search', true)
            api._getSearch()
          } else {
            search = undefined
            $scope.flags.isSearching = false
            api._resetTabObject('search', false)
          }
        }
      }
    )

    headerInfo.headerToolbar.repositoryFilter = null
    headerInfo.headerToolbar.rightButtons = []

    $scope.headerToolbar = headerInfo.headerToolbar
    $scope.headerNavigation = headerInfo.headerNavigation
    $scope.headerTitle = headerInfo.headerTitle
  }

  /**
   * @param {number} userId
   */
  function _getTabsCounts (userId) {
    RepositoryService.getSharedAssetPacksSummaryCount().then((tabsCounts) => {
      $scope.tabsCounts = tabsCounts
    }).finally(() => {
      $scope.flags.loadingTabCounts = false
    })
  }

  /**
   * @param {"active" | "expired" | "search"} scopeObjectKey
   */
  function _getShowMore (scopeObjectKey) {
    const tabObject = $scope[scopeObjectKey]
    tabObject.$skip = tabObject.$skip + tabObject.$top

    tabObject.loadingMore = true
    tabObject.getItems().then(() => {
      tabObject.loadingMore = false
    })
  }

  function _getActive () {
    const params = {
      $top: $scope.active.$top,
      $skip: $scope.active.$skip,
      $sort: $scope.active.$sort,
      $order: $scope.active.$order
    }

    return RepositoryService.getSharedAssetPacks(params).then(result => {
      $scope.active.items.push(...result.rows)
      $scope.active.count = result.count
      $scope.active.loading = false
    })
  }

  function _getExpired () {
    const params = {
      $top: $scope.expired.$top,
      $skip: $scope.expired.$skip,
      $sort: $scope.expired.$sort,
      $order: $scope.expired.$order,
      status: 'EXPIRED'
    }

    return RepositoryService.getSharedAssetPacks(params).then(result => {
      $scope.expired.items.push(...result.rows)
      $scope.expired.count = result.count
      $scope.expired.loading = false
    })
  }

  function _getSearch () {
    const params = {
      $top: $scope.search.$top,
      $skip: $scope.search.$skip,
      $sort: $scope.search.$sort,
      $order: $scope.search.$order,
      search
    }

    if ($scope.selectedTab === 'expired') {
      params.status = 'EXPIRED'
    }

    return RepositoryService.getSharedAssetPacks(params).then(result => {
      $scope.search.items.push(...result.rows)
      $scope.search.count = result.count
      $scope.search.loading = false
    })
  }

  /**
   * @param {object} scopeObjectKey
   */
  $scope.handleTabChange = async event => {
    if (event.detail.selected && event.detail.selected !== $scope.selectedTab) {
      $scope.selectedTab = event.detail.selected
      return
    }

    switch ($scope.selectedTab) {
      case 'active':
        api._resetTabObject('active', true)
        api._getActive()
        break
      case 'expired':
        api._resetTabObject('expired', true)
        api._getExpired()
        break
    }
  }

  /**
   * @param {"active" | "expired" | "search"} scopeObjectKey
   * @param {string} columnName
   */
  $scope.onChangeSort = (scopeObjectKey, columnName) => {
    const currentTabObject = $scope[scopeObjectKey]
    const currentSort = currentTabObject.$sort
    const currentOrder = currentTabObject.$order
    let order = currentOrder
    let sort = columnName

    api._resetTabObject(scopeObjectKey, true)

    const newTabObject = $scope[scopeObjectKey]

    if (!currentSort || currentSort === columnName) {
      if (!currentOrder) {
        order = 'ASC'
      } else if (currentOrder === 'ASC') {
        order = 'DESC'
      } else {
        order = undefined
        sort = undefined
      }
    }

    newTabObject.$sort = sort
    newTabObject.$order = order
    newTabObject.getItems()
  }

  $scope.onItemUpdate = () => {
    api._getTabsCounts()

    if ($scope.flags.isSearching) {
      api._resetTabObject('search', true)
      api._getSearch()
    } else {
      api._resetTabObject($scope.selectedTab, true)
      $scope[$scope.selectedTab].getItems()
    }
  }

  $scope.scrollShowMore = api._getShowMore
}

export { SharedPacksController }
